import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/common/Header";
import HeroSection from "./HeroSection";
import Footer from "../../components/common/Footer";
import ProcurementSection from "./ProcurementSection";
import ContactSection from "../../components/common/ContactSection";

const BiospecimenCategory = () => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpanded = (index) => {
    setExpandedItems((prev) => ({ ...prev, [index]: !prev[index] }));
  };
  const customData = [
    {
      title: "Inventory / Retrospective Collections",
      description:
        "Access existing specimens from our curated biobank. Pre-characterized samples with available clinical data, ready for immediate shipment. Ideal for pilot studies, method validation, or when you need samples quickly.",
    },
    {
      title: "Prospective Collections",
      description:
        "Custom-designed specimen collection following your specific protocol. Define inclusion criteria, collection methods, processing requirements, and data annotations. Perfect for studies requiring fresh samples or specific patient populations.",
    },
    {
      title: "Matched Sets",
      description:
        "Paired specimens from the same donor: tumor/normal tissue, pre/post-treatment samples, or longitudinal series. Matched clinical data enables powerful comparative analyses and biomarker discovery.",
    },
  ];

  const customData2 = [
    {
      title: "Ethical Collection",
      description:
        "IRB-approved protocols, informed consent documentation, full regulatory compliance with international guidelines.",
    },
    {
      title: "Quality Assurance",
      description:
        "SOP-driven processing, validated storage conditions, comprehensive chain of custody documentation.",
    },
    {
      title: "Data Security",
      description:
        "De-identified specimens, HIPAA-compliant data handling, secure data transfer protocols.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>ANVIYA Biospecimen Services</title>
      </Helmet>

      <main className="w-full bg-white">
        <HeroSection />
        <ProcurementSection />
        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default BiospecimenCategory;
